import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getTalents } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';


class Talentsearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      talents:[],
      keyword:'',
      experience:'',
      allowedtoacess:false
    }

    this.searchGo = this.searchGo.bind(this);

  }



  componentDidMount() {

        let dataOfUser = this.state.auth_data;
        let allowedtoacess = (dataOfUser.upgraded==1)?true:(dataOfUser.current_plan!=5 && dataOfUser.current_plan!=0 && dataOfUser.current_plan!=1)?true:false;
        this.setState({allowedtoacess:allowedtoacess}); 
        this.getTalents();

  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getTalents(){


    let req = JSON.stringify({})

    getTalents(req).then((response) => {

        if(response.status==1){
          this.setState({talents:response.list});
          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

        }else{
          
          this.setState({talents:[]});
             
        }

    });

  }

  searchGo(){

    this.setState({loading:true});

    let req = JSON.stringify({})

    getTalents(req).then((response) => {

        if(response.status==1){
          this.setState({loading:false, talents:response.list});
          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

        }else{
          
          this.setState({loading:false, talents:[]});
             
        }

    });

  }


  render() {
        const { list, talents } = this.state;
       
 
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">

                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
 

                    <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                                <div class="boxtitle"><img src="../../images/profile/about.png" />Talent Search {this.state.allowedtoacess}</div>

                                <div class="simple_filters">
                                    
                                    <div class="selectbox">
                                        <select name="level" class="forminputcls pad10" onChange={this.handleChange}>
                                            <option value="">Select Level</option>
                                            <option value="Preschool">Preschool</option>
                                            <option value="Primary School">Primary School</option>
                                            <option value="Middle School">Middle School</option>
                                            <option value="Secondary School">Secondary School</option>
                                            <option value="Higher Secondary School">Higher Secondary School</option>
                                            <option value="Leadership">Leadership</option>
                                            <option value="Administration">Administration</option>
                                            <option value="Others">Others</option>
                                        </select>
                                    </div>

                                    <div class="selectbox">
                                        <select name="role" class="forminputcls pad10"><option value="">Select Role</option><option value="Pre Primary Teacher">Pre Primary Teacher</option><option value="Primary Teacher">Primary Teacher</option><option value="Secondary Teacher">Secondary Teacher</option><option value="Senior Secondary Teacher">Senior Secondary Teacher</option><option value="Special Educator">Special Educator</option><option value="Libraian">Libraian</option><option value="Physial Education Teacher">Physial Education Teacher</option><option value="Counsellor">Counsellor</option><option value="Administrator">Administrator</option><option value="Accountant">Accountant</option><option value="Marketing">Marketing</option><option value="Music / Dance Teacher">Music / Dance Teacher</option><option value="Other">Other</option></select>
                                    </div>

                                    <div class="selectbox">
                                        <select name="role_type" class="forminputcls pad10"><option value="">Select Role Type</option><option value="Full Time">Full Time</option><option value="Part Time">Part Time</option><option value="Contractual">Contractual</option><option value="Temporary">Temporary</option><option value="Internship">Internship</option></select>
                                    </div>

                                    <div class="selectbox">
                                        <select name="job_subject_teaching" class="forminputcls pad10"><option value="">Select Subject of Teaching</option><option value="Biology">Biology</option><option value="Science">Science</option><option value="Maths">Maths</option><option value="Physics">Physics</option><option value="Chemistry">Chemistry</option><option value="Art">Art</option><option value="History">History</option><option value="Economics">Economics</option><option value="Computer Science">Computer Science</option><option value="Phyisical Education">Phyisical Education</option><option value="Librarian">Librarian</option><option value="Humanities">Humanities</option><option value="Geography">Geography</option><option value="Civics">Civics</option><option value="English">English</option><option value="Hindi">Hindi</option><option value="Tamil">Tamil</option><option value="Kannada">Kannada</option><option value="Telugu">Telugu</option><option value="Marathi">Marathi</option><option value="French">French</option><option value="Spanish">Spanish</option><option value="German">German</option><option value="Reglion and Religious Studies">Reglion and Religious Studies</option><option value="Visual Arts">Visual Arts</option><option value="Robotics &amp; Coding">Robotics &amp; Coding</option><option value="Other">Other</option></select>
                                    </div>


                                    <div class="gobox">
                                      <button class="btn btn-main" onClick={this.searchGo}>Filter</button>
                                    </div>
                                </div>
                                
                                {!this.state.loading &&

                                <div class="listingsapplicants">
                    
                    {talents.length>0  && talents.map((item, i) => { 

                    
                            return <div class="eachapplicantrow">

                                  <div class="iconbag"><img src={"../../images/profile.png"}/></div>
                                  <div class="jobdetail">
                                        <div class="jobname">{item.name}</div>
                                        <div class="jobclass">{(item.aboutme) ? (item.aboutme.length > 300 ? `${item.aboutme.substring(0, 254)}...` : item.aboutme):""}</div>
                                        <div class="jobattributes tags">
                                            <span class="tag"><img src={"../../images/ins/experience.png"}/>&nbsp;{item.area_of_interests}</span>
                                            <span class="tag"><img src={"../../images/ins/timer.png"}/>&nbsp;{item.total_years_experiece} years exp</span>
                                            
                                        </div>
                                  </div>

                                  <div class="buttonsec_sm">
                                                                  
                                      <div><a href={"/partner/wctalentsearch/viewprofile/"+item.id} class="btn btn-main-full">View Profile</a></div>
                                  </div>  

                                   
                          </div>

                          })}

                    {talents.length==0 &&
                    
                    <div class="nodata">No Data</div>
                    
                    }

                    </div>

                            }

                            {this.state.loading &&
                              <div class="blueloading"> Please wait...it is loading...</div>
                            }


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Talentsearch;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/talentsearch.jsx